import React, { useEffect } from 'react';
import { CustomModalLayout, Modal, Text } from '@wix/design-system';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { appMarketPendingForDeleteModalCloseModal, appMarketPendingForDeleteModalGoToEditorClick, appMarketPendingForDeleteModalLoaded, } from '@wix/bi-logger-app-market-data/v2';
import { useTranslation } from '../../../hooks/use-translation';
export const DeleteEditorModalFromBM = ({ appId, appName, handleClose, msid, openDeleteModalAppInEditor, }) => {
    const biLogger = useBiLogger();
    const t = useTranslation();
    const title = t('manage-apps.delete-page-header', {
        name: appName,
    })
        .replaceAll('&amp;', '&')
        .replaceAll('&#x2F;', '/');
    useEffect(() => {
        biLogger
            .report(appMarketPendingForDeleteModalLoaded({
            app_id: appId,
            msid,
        }))
            .catch((e) => console.log(e));
    }, []);
    const onGoToEditorClick = () => {
        openDeleteModalAppInEditor(appId);
        biLogger
            .report(appMarketPendingForDeleteModalGoToEditorClick({
            app_id: appId,
            msid,
        }))
            .catch((e) => console.log(e));
        handleClose();
    };
    const onCloseClick = () => {
        biLogger
            .report(appMarketPendingForDeleteModalCloseModal({
            app_id: appId,
            msid,
        }))
            .catch((e) => console.log(e));
        handleClose();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(CustomModalLayout, { width: "510px", title: title, dataHook: "delete-editor-app-from-bm-modal", primaryButtonText: t('manage-apps.delete-editor-from-bm-go'), primaryButtonOnClick: onGoToEditorClick, secondaryButtonText: t('manage-apps.delete-editor-from-bm-cancel'), secondaryButtonOnClick: onCloseClick, onCloseButtonClick: onCloseClick },
            React.createElement(Text, null, t('manage-apps.delete-editor-from-bm')))));
};
//# sourceMappingURL=delete-editor-modal-from-BM.js.map